import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IBreadcrumb } from './interfaces/breadcrumb.interface';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-breadcrumbs',
  imports: [TranslatePipe, RouterLink],
  templateUrl: './breadcrumbs.html',
  styleUrl: './breadcrumbs.scss',
})
export class Breadcrumbs {
  items = input<IBreadcrumb[]>([]);
}
